import React from "react";
import PropTypes from "prop-types";
import keyBy from "lodash/keyBy";

import Tile, {
  TileTitle,
  TileHeader,
  TileBody
} from "shared/react_components/Tile";
import StaticExpressionCollapse from "shared/expression_builder/components/StaticExpressionCollapse";
import StaticRawExpressionResult from "shared/expression_builder/components/StaticRawExpressionResult";

const CallRecordingDetails = ({ expression, evaluationResult, disqualifiedExpression, expressionNodes, terminalMetadata }) => (
  <Tile>
    <TileHeader>
      <TileTitle>Call Recording Details</TileTitle>
    </TileHeader>
    <TileBody>
      {expression ? (
        <div>
          <StaticRawExpressionResult
            qualified={evaluationResult}
            rawExpression={evaluationResult ? expression : disqualifiedExpression}
            rawExpressionTitle="Results of Call Recording Condition"
          />
          <StaticExpressionCollapse
            expressionText={expression}
            expressionNodes={expressionNodes || []}
            terminalMetaData={keyBy(terminalMetadata, "keyName")}
            closeButtonLabel="Hide Recording Condition"
            openButtonLabel="View Recording Condition"
          />
        </div>
      ) : (
        <p>No additional recording details.</p>
      )}
    </TileBody>
  </Tile>
);

CallRecordingDetails.propTypes = {
  expression: PropTypes.string,
  evaluationResult: PropTypes.bool,
  disqualifiedExpression: PropTypes.string,
  expressionNodes: PropTypes.array,
  terminalMetadata: PropTypes.array
};

export default CallRecordingDetails;
